<template lang="pug">
v-row(align="start" class=" tw-h-16 tw-bg-white  tw-z-40")
  v-col(cols="auto")
    template(v-if="website.logo")
      v-img(:src="path(website.logo)" class="tw-w-24 tw-h-24 tw-shadow-md tw-mx-6")
    template(v-else)
      span(:class="titleColor" class=" tw-text-lg tw-font-bold") realtor

  v-col(cols="stretch")
  v-col(cols="auto")
    v-row(no-gutters class=" tw--mt-3")
      v-col(cols="auto" v-if="website.pages.home.published")
        v-btn(
          small
          :to="`/website`"
          height="65px"
          width="80px"
          tile
          exact
          text
          color="black"
          class="tw-p-0 tw-m-0"
        ) {{ website.pages.home.name }}
      v-col(cols="auto" v-if="website.pages.rent.published")
        v-btn(
          small
          :to="`/website/${website.pages.rent.slug}`"
          height="65px"
          width="80px"
          tile
          text
          color="black"
          class="tw-p-0 tw-m-0"
        ) {{ website.pages.rent.name }}
      v-col(cols="auto" v-if="website.pages.buy.published")
        v-btn(
          small
          :to="`/website/sale`"
          height="65px"
          width="80px"
          tile
          text
          color="black"
          class="tw-p-0 tw-m-0"
        ) {{ website.pages.buy.name }}
      v-col(cols="auto" v-if="website.pages.about.published")
        v-btn(
          small
          :to="`/website/${website.pages.about.slug}`"
          height="65px"
          width="80px"
          tile
          text
          color="black"
          class="tw-p-0 tw-m-0"
        ) {{ website.pages.about.name }}
      v-col(cols="auto" v-if="website.pages.contact.published")
        v-btn(
          small
          :to="`/website/${website.pages.contact.slug}`"
          height="65px"
          width="80px"
          tile
          text
          color="black"
          class="tw-p-0 tw-m-0"
        ) {{ website.pages.contact.name }}
  v-col(cols="1")
</template>
<script>
export default {
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
